import $ from 'jquery';
import Router from 'root/router';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import View from 'view/base';
import View_Menu from 'page/account/menu';
import View_Integration_Log from 'view/integration_log_row';
import Tooltip from 'root/module/tooltip';

const integrations = [
    {
        name: 'Slack',
        value: 'slack',
        icon: '/image/slack_small.png'
    },
    {
        name: 'Teams',
        value: 'microsoft_teams',
        icon: '/image/teams_small.png',
    },
    {
        name: 'Jira',
        value: 'jira',
        icon: '/image/jira_small.png'
    },
    {
        name: 'ClickUp',
        value: 'clickup',
        icon: '/image/clickup_small.png'
    },
    {
        name: 'Asana',
        value: 'asana',
        icon: '/image/asana_small.png'
    },
    {
        name: 'Notion',
        value: 'notion',
        icon: '/image/notion_small.png',
    },
    {
        name: 'Linear',
        value: 'linear',
        icon: '/image/linear_small.png',
    },
    {
        name: 'Teamwork',
        value: 'teamwork',
        icon: '/image/teamwork_small.png',
    },
    {
        name: 'Trello',
        value: 'trello',
        icon: '/image/trello_small.png',
    },
    {
        name: 'Azure',
        value: 'azure_devops',
        icon: '/image/azure_devops_small.png',
    },
    {
        name: 'Zapier',
        value: 'zapier',
        icon: '/image/zapier_small.png',
    },
    {
        name: 'Github',
        value: 'github',
        icon: '/image/github_small.png',
    },
    {
        name: 'Gitlab',
        value: 'gitlab',
        icon: '/image/gitlab_small.png',
    },
    {
        name: 'Monday',
        value: 'monday',
        icon: '/image/monday_small.png',
    },
    {
        name: 'Basecamp',
        value: 'basecamp',
        icon: '/image/basecamp_small.png',
    },
    {
        name: 'Wrike',
        value: 'wrike',
        icon: '/image/wrike_small.png',
    },
    {
        name: 'Zendesk',
        value: 'zendesk',
        icon: '/image/zendesk_small.png',
    },
    {
        name: 'Webhook',
        value: 'webhook',
        icon: '/image/webhook_small.png'
    },
    {
        name: 'Email Forwarding',
        value: 'email',
        icon: '/image/email_forwarding_small.png'
    }
];
const methods = ['GET', 'POST', 'PUT', 'DELETE'];
const response_codes = [
    {
        label: 'Succeeded',
        value: 'succeeded',
    },
    {
        label: 'Failed',
        value: 'failed',
    }
];

export default View.extend({
    tagName: 'section',

    collection: null,


    page: 1,
    limit: 30,
    total: null,

    views: {
        menu: {},
        integration_logs: {}
    },

    events: {
        'click .page-previous'                : 'onPagePrevious',
        'click .page-next'                    : 'onPageNext',
        'click .log-search-launcher'          : 'onToggleLogSearch',
        'keyup .log-search-launcher input'    : 'onSearchLog',
        'click .quick-search-clear'           : 'onClearSearch',
        'click .dropdown-date-range'          : 'onClickDropdownDareRange',
        'click .date-range-search'            : 'onSearchDateRange',
        'click .date-range-reset'             : 'onResetDateRange',
        'click .dropdown-integration li'      : 'onSelectIntegration',
        'click .dropdown-method li'           : 'onSelectMethod',
        'click .dropdown-response-code li'    : 'onSelectResponseCode',
        'click .filters-clear'                : 'onClearFilters',
        'click .create-key'                   : 'createKey'
    },

    dom_handlers: {
        onPagePrevious: function(e) {
            if (this.page <= 1) {
                return;
            }

            this.page--;

            this.search();
        },

        onPageNext: function(e) {
            var total_page = Math.ceil(this.total / this.limit);

            if (this.page >= total_page) {
                return;
            }

            this.page++;

            this.search();
        },

        onSelectIntegration: function(e) {
            var integration = $(e.currentTarget).data('val');
            var is_all = !integration;

            e.stopPropagation();

            if (is_all) {
                this.filters.integrations = [];
            } else {
                var index = this.filters.integrations.indexOf(integration);
                if (index === -1) {
                    this.filters.integrations.push(integration);
                } else {
                    this.filters.integrations.splice(index, 1);
                }

                var all_selected = integrations.every((item) => {
                    return this.filters.integrations.includes(item.value);
                });

                if (all_selected) {
                    this.filters.integrations = [];
                }
            }

            this.updateFilters(this.$el.find('.button-dropdown-integration'), this.filters.integrations);
            this.search();
        },

        onToggleLogSearch: function(e) {
            this.$el.find('.log-search-launcher').addClass('active');
        },

        onSearchLog: function(e) {
            var value = $(e.currentTarget).val().toLowerCase().trim();

            if (e.keyCode !== 13) {
                return;
            }

            this.filters.search = value;
            this.search();
            this.$el.find('.quick-search-clear').toggle(!!value);
        },

        onClearSearch: function() {
            this.filters.search = '';

            this.$el.find('.log-search-launcher input').val('');
            this.$el.find('.quick-search-clear').hide();
            this.search();
        },

        onClickDropdownDareRange: function(e) {
            e.stopPropagation();
        },

        onSearchDateRange: function() {
            var from = this.$el.find('input[name="from"]').val();
            var to = this.$el.find('input[name="to"]').val();

            this.filters.from = from;
            this.filters.to = to;

            this.$el.find('.dropdown-date-range').hide();
            this.renderFilters();
            this.search();
        },

        onResetDateRange: function() {
            this.$el.find('input[name="from"]').val('');
            this.$el.find('input[name="to"]').val('');
        },

        onSelectMethod: function(e) {
            var method = $(e.currentTarget).data('val');
            var is_all = !method;

            e.stopPropagation();

            if (is_all) {
                this.filters.methods = [];
            } else {
                var index = this.filters.methods.indexOf(method);
                if (index === -1) {
                    this.filters.methods.push(method);
                } else {
                    this.filters.methods.splice(index, 1);
                }

                var all_selected = methods.every((item) => {
                    return this.filters.methods.includes(item);
                });

                if (all_selected) {
                    this.filters.methods = [];
                }
            }

            this.updateFilters(this.$el.find('.button-dropdown-method'), this.filters.methods);
            this.search();
        },

        onSelectResponseCode: function(e) {
            var value = $(e.currentTarget).data('val');
            var is_all = !value;

            e.stopPropagation();

            if (is_all) {
                this.filters.status = [];
            } else {
                var index = this.filters.status.indexOf(value);

                if (index === -1) {
                    this.filters.status.push(value);
                } else {
                    this.filters.status.splice(index, 1);
                }

                var all_selected = response_codes.every((item) => {
                    return this.filters.status.includes(item.value);
                });

                if (all_selected) {
                    this.filters.status = [];
                }
            }

            this.updateFilters(this.$el.find('.button-dropdown-response-code'), this.filters.status);
            this.search();
        },

        onClearFilters: function(e) {
            e.preventDefault();

            this.filters.search = '';
            this.filters.integrations = [];
            this.filters.methods = [];
            this.filters.status = [];
            this.filters.from = '';
            this.filters.to = '';

            this.renderFilters();
            this.search();
            Tooltip.removeAll();
        },

        onDocumentClick: function(e) {
            if (!$(e.target).parents('.log-search-launcher').length) {
                this.$el.find('.log-search-launcher').removeClass('active');
            }

            if (
                !$(e.target).parents('.button-dropdown-date-range').length &&
                !$(e.target).parents('.dropdown-date-range').length
            ) {
                this.$el.find('.dropdown-date-range').hide();
            }
        },
    },

    event_handlers: {
    },

    initialize: function() {
        this.views.menu = new View_Menu();

        this.filters = {
            search: '',
            integrations: [],
            methods: [],
            status: [],
            from: '',
            to: '',
        };

        this.on('remove', () => {
            $(document).off('click.log_search');
        });
    },

    search: function() {
        this.total = null;

        Router.addMultipleQueryString({
            p: this.page,
        });

        // search
        Cache.app.request({
            action: 'integration/searchLogs',
            context: this,
            data: {
                page         : this.page,
                limit        : this.limit,
                search       : this.filters.search,
                integrations : this.filters.integrations,
                methods      : this.filters.methods,
                status       : this.filters.status,
                from         : this.filters.from,
                to           : this.filters.to,
            },
            success: function(response) {
                this.$el.find('.table-loader').remove();

                this.total = response.total;

                this.views.integration_logs = {};
                Cache.integration_log.reset(response.data);
                Cache.integration_log.each((model) => {
                    this.views.integration_logs['_' + model.id] = new View_Integration_Log({model: model});
                });

                if (!Cache.integration_log.length) {
                    this.$el.find('.search-result-empty').addClass('active');
                } else {
                    this.$el.find('.search-result-empty').removeClass('active');
                }

                this.renderLogs();
            }
        });
    },

    onPageReady: function() {
        this.search();

        $(document).on('click.log_search', this.dom_handlers.onDocumentClick.bind(this));
    },

    hasFilters: function() {
        var has_filters =  false;

        if (this.filters.integrations.length) {
            has_filters = true;
        } else if (this.filters.methods.length) {
            has_filters = true;
        } else if (this.filters.status.length) {
            has_filters = true;
        } else if (this.filters.from || this.filters.to) {
            has_filters = true;
        }

        return has_filters;
    },

    renderFilters: function() {
        var integration_options = '';
        var method_options = '';
        var response_code_options = '';

        // build integration options
        integrations.forEach((integration) => {
            integration_options += '<li' + (this.filters.integrations.indexOf(integration.name) === -1 ? '' : ' class="selected"') + ' data-val="' + integration.value + '"><div class="flex-start"><img class="integration-logo" src="' + integration.icon + '" /><span class="margin-left-4">' + integration.name + '</span></div></li>';
        });

        // build method options
        methods.forEach((method) => {
            method_options += '<li' + (this.filters.methods.indexOf(method) === -1 ? '' : ' class="selected"') + ' data-val="' + method + '">' + method + '</li>';
        });

        // build response code options
        response_codes.forEach((code) => {
            response_code_options += '<li' + (this.filters.status.includes(code.value) ? ' class="selected"' : '') + ' data-val="' + code.value + '">' + code.label + '</li>';
        });

        var html =
        '<div class="log-search-launcher">' +
            '<input type="text" placeholder="Search logs...">' +
            '<button type="button" class="quick-search-clear" style="display: none;"><i class="fas fa-times-circle info"></i></button>' +
        '</div>' +

        // integration filter
        '<div class="button-dropdown-integration button-dropdown button-dropdown-large button-dropdown-left button-dropdown-integration" data-trim="false">' +
            '<button type="button" class="dropdown-select dropdown-select-small dropdown-select-text-invert font-weight-medium">' +
                '<div class="flex-c">' +
                    '<span>Integration</span>' +
                    '<div class="select-num">' +
                        (this.filters.integrations.length === 0 ? '' : '<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.filters.integrations.length + '</span>') +
                    '</div>' +
                '</div>' +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-integration">' +
                    '<li data-val=""' + (this.filters.integrations.length === 0 ? ' class="selected"' : '') + '>All</li>' +
                    '<li class="separator"></li>' +
                    integration_options +
                '</ul>' +
            '</div>' +
        '</div>' +

        // method filter
        '<div class="button-dropdown-method button-dropdown button-dropdown-left margin-left-16" data-trim="false">' +
            '<button type="button" class="dropdown-select dropdown-select-small dropdown-select-text-invert font-weight-medium">' +
                '<div class="flex-c">' +
                    '<span>Method</span>' +
                    '<div class="select-num">' +
                        (this.filters.methods.length === 0 ? '' : '<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.filters.methods.length + '</span>') +
                    '</div>' +
                '</div>' +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-method">' +
                    '<li data-val=""' + (this.filters.methods.length === 0 ? ' class="selected"' : '') + '>All</li>' +
                    '<li class="separator"></li>' +
                    method_options +
                '</ul>' +
            '</div>' +
        '</div>' +

        // response code filter
        '<div class="button-dropdown-response-code button-dropdown button-dropdown-left margin-left-16" data-trim="false">' +
            '<button type="button" class="dropdown-select dropdown-select-small dropdown-select-text-invert font-weight-medium">' +
                '<div class="flex-c">' +
                    '<span>Status</span>' +
                    '<div class="select-num">' +
                        (this.filters.status.length ? '<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + this.filters.status.length + '</span>' : '') +
                    '</div>' +
                '</div>' +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select dropdown-response-code">' +
                    '<li data-val=""' + (this.filters.status.length ? '' : ' class="selected"') + '>All</li>' +
                    '<li class="separator"></li>' +
                    response_code_options +
                '</ul>' +
            '</div>' +
        '</div>' +

        // date filter
        '<div class="button-dropdown button-dropdown-full button-dropdown-left button-dropdown-date-range margin-left-16">' +
            '<button type="button" class="dropdown-select dropdown-select-small dropdown-select-text-invert font-weight-medium">Date' + (this.filters.from || this.filters.to ? '<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">1</span>' : '') + '</button>' +
            '<div class="dropdown-date-range">' +
                '<div class="form-fluid">' +
                    '<div class="grid-6-6">' +
                        '<div class="margin-right-4">' +
                            '<div class="field-label margin-bottom-8">Created from</div>' +
                            '<input type="date" class="solid medium" name="from" value="' + this.filters.from + '">' +
                        '</div>' +
                        '<div class="margin-left-4 margin-bottom-8">' +
                            '<div class="field-label">To</div>' +
                            '<input type="date" class="solid medium" name="to" value="' + this.filters.to + '">' +
                        '</div>' +
                    '</div>' +
                    '<div class="margin-top-30 margin-bottom-0">' +
                        '<button class="primary medium date-range-search">Search</button>' +
                        '<a href="#" class="cancel date-range-reset" style="display:none;">Clear search</a>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +

        '<button type="button" class="filters-clear small text-link tooltip" data-title="Clear filters" data-offset="0,10"' + (this.hasFilters() ? '' : 'style="display: none;"') + '>Clear</button>';

        this.$el.find('.region-filters').html(html);
    },

    updateFilters: function($el, selected) {
        var is_all = selected.length === 0;

        $el.find('.dropdown-select li').removeClass('selected');

        if (is_all) {
            $el.find('.dropdown-select li[data-val=""]').addClass('selected');
            $el.find('.select-num').html('');
        } else {
            selected.forEach((item) => {
                var val = typeof item === 'string' ? item : item.value;

                $el.find('.dropdown-select li[data-val="' + val + '"]').addClass('selected');
            });

            $el.find('.select-num').html('<span class="badge-primary badge-small badge-round badge-fluid font-weight-semibold margin-left-8">' + selected.length + '</span>');
        }

        if (this.hasFilters()) {
            this.$el.find('.filters-clear').show();
        } else {
            this.$el.find('.filters-clear').hide();
        }
    },

    renderLogs: function() {
        var html = '<div class="region"></div>';
        this.$el.find('.region-logs').html(html);

        _.each(this.views.integration_logs, (view) => {
            this.$el.find('.region-logs > div:first').append(view.render().el);
        });

        var total_page = Math.ceil(this.total / this.limit);

        this.$el.find('.region-pagination').toggle(!!this.total).find('.current-page b').html(this.page + ' of ' + total_page);
    },

    render: function() {
        UI.setPageTitle('Logs');

        var total_page = Math.ceil(this.total / this.limit);
        var first_feedback_project = Cache.project.findWhere({is_archived: false, project_type: 'feedback'});

        var content =
        '<main class="xlarge">' +
            '<div class="filter-bar flex-between">' +
                '<div class="region-filters"></div>' +
                '<div class="text-info">Logs are retained for up to 14 days.</div>' +
            '</div>' +
            '<div class="region-logs"></div>' +
            '<div class="search-result-empty margin-top-24">' +
                '<p>No logs were found in your account.</p>' +
                (first_feedback_project ?
                '<p><a href="/' + first_feedback_project.get('project_key') + '/integration/" class="navigation primary"><i class="fa-solid fa-plus"></i> Connect Integrations</a></p>' : '') +
            '</div>' +
            '<div class="table-loader">' +
                '<div class="loader-placeholder-medium margin-top-20"></div>' +
                '<div class="loader-placeholder-medium margin-top-16"></div>' +
                '<div class="loader-placeholder-medium margin-top-16"></div>' +
            '</div>' +
            '<div class="region-pagination text-align-center" style="display: none;">' +
                '<div class="button-group margin-top-24" data-autohighlight="false">' +
                    '<button class="page-previous text small inline"><i class="far fa-angle-left"></i></button>' +
                    '<button class="small inline current-page"><b>' + this.page + ' of ' + total_page + '</b></button>' +
                    '<button class="page-next text small inline"><i class="far fa-angle-right"></i></button>' +
                '</div>' +
            '</div>' +
        '</main>';

        this.$el.html(content);

        this.views.menu.render().$el.prependTo(this.$el.find('main'));

        this.renderFilters();
        this.renderLogs();
        return this;
    }
});